export default __webpack_public_path__ + "static/donations-73babb5b4facf194e14e370aeb2d0ea8.jpg";